import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { GpuFormFieldAppearance } from '@geneplanet/ngx-ui/src/lib/form-field';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AnalysesTypesLowercase } from 'src/app/analyses/interfaces/analyses.types';
import { AnalysesService } from 'src/app/analyses/services/analyses.service';
import { BloodConfiguration } from '../../interfaces/blood-configuration.interface';
import { BloodAnalysisResult } from '../../interfaces/blood-analysis-result.interface';

@Component({
  templateUrl: './blood-add-marker-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BloodAddMarkerModalComponent implements AfterViewInit {
  public analysisId: string;
  public resultId: string | null = null;
  public editMode = false;
  public local = false;
  public analysisResult: BloodAnalysisResult;

  protected GpuFormFieldAppearance = GpuFormFieldAppearance;
  protected configuration: BloodConfiguration;
  protected showBackButton = false;

  constructor(
    public modal: NgbActiveModal,
    private cdRef: ChangeDetectorRef,
    private analysesService: AnalysesService
  ) {}

  ngAfterViewInit() {
    // To avoid possible ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.loadAnalysis();

      // When editing already server saved
      if (this.resultId) {
        this.loadResult();
      }
    });
  }

  private loadAnalysis() {
    this.analysesService
      .bloodConfiguration(this.analysisId)
      .subscribe((configuration: BloodConfiguration) => {
        this.configuration = configuration;
        this.cdRef.markForCheck();
      });
  }

  private loadResult() {
    this.analysesService
      .getAnalysis(
        this.analysisId,
        this.resultId,
        false,
        AnalysesTypesLowercase.Blood
      )
      .subscribe((analysisResult: BloodAnalysisResult) => {
        this.analysisResult = analysisResult;
        this.cdRef.markForCheck();
      });
  }
}
